import React, { useState, useEffect, useContext } from 'react';
import ControlButtonAdd from './ControlButtonAdd';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlButtonShow from './ControlButtonShow';
import ControlButtonVisibility from './ControlButtonVisibility';
import ControlItem from './ControlItem';
import Pager from './Pager';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';

import MyParticipateWaysContext from '../context/ParticipateWaysContext';

/* import ModalNews from './ModalNews'; */
import ModalItemsDelete from './ModalItemsDelete';
import ModalParticipateWaysAdd from './ModalParticipateWaysAdd';
import ModalParticipateWaysUpdate from './ModalParticipateWaysUpdate';
/* import ModalNewsAdd from './ModalNewsAdd'; */
/* import ModalNewsUpdate from './ModalNewsUpdate'; */

const ControlParticipate = () => {
    const {getParticipateWaysAdmin, participateWays, files, maxPage, setPageAdmin, pageAdmin, error, loading, setParticipateWay, setImage, setError, changeParticipateWayVisibility, deleteParticipateWay } = useContext(MyParticipateWaysContext);

    /* const[isModalOpen, setIsModalOpen] = useState(false); */
    const[isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const[isModalAddOpen, setIsModalAddOpen] = useState(false);
    const[isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);

    const[itemId, setItemId] = useState(null);
    const[successAlert, setSuccessAlert] = useState(null);

    const handleChangeParticipateWayVisibility = async (participateWayId) => {
        const res = await changeParticipateWayVisibility(participateWayId);
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        }else{
            setError({"error": false, "message": ""})
            setSuccessAlert("Visibilidad cambiada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 2000);
        }
    }

    useEffect(() =>  {
        getParticipateWaysAdmin();
    }, [pageAdmin]);

    useEffect(() => {
        setPageAdmin(0);
    }, []);

    return (
        <div className='animation-appear-top-center'>
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteParticipateWay} itemId={itemId} />
            <ModalParticipateWaysAdd isModalAddOpen={isModalAddOpen} setIsModalAddOpen={setIsModalAddOpen} setSuccessAlert={setSuccessAlert} />
            <ModalParticipateWaysUpdate isModalUpdateOpen={isModalUpdateOpen} setIsModalUpdateOpen={setIsModalUpdateOpen} setSuccessAlert={setSuccessAlert} />
            <SuccessAlert isVisible={successAlert} />
            <div className='flex flex-col'>
                <ControlButtonAdd onClick={()=>setIsModalAddOpen(true)} />
                {error.error && <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1>}
                {participateWays && participateWays.length > 0 && participateWays.map((participateWay, index) => (
                    <ControlItem key={index} title={participateWay.participateWayTitle} text={participateWay.participateWayDescription}>
                        {/* <ControlButtonShow onClick={()=>{setParticipateWay(participateWay);setImage(`data:image/png;base64,${files[index]}`); setIsModalOpen(true)}} /> */}
                        <ControlButtonUpdate onClick={()=>{setParticipateWay(participateWay); setIsModalUpdateOpen(true)}} />
                        <ControlButtonVisibility visible={participateWay.visible} onClick={()=>handleChangeParticipateWayVisibility(participateWay.participateWayId)} />
                        <ControlButtonDelete onClick={()=>{setItemId(participateWay.participateWayId); setIsModalItemsDeleteOpen(true)}} />
                    </ControlItem>
                ))}
                <div>
                    <Loading isLoading={loading} />
                    {participateWays && participateWays.length < 1 && <h1 className='text-center w-full font-light my-4'>No hay registros para mostrar</h1>}
                    <div className='flex justify-center mb-4'>
                        <Pager maxPage={maxPage} setPage={setPageAdmin} />
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default ControlParticipate;